import * as React from 'react';
import { useEffect, useState } from 'react'
import PageLinks from './PageLinks';
import UserMenu from './UserMenu';
import AppBar from '@mui/material/AppBar';
import { Box, Toolbar } from '@mui/material';
import Container from '@mui/material/Container';

import Logo from './Logo';
import LoginButton from './LoginButton';
import DemoButton from './SignUpButton';
import HeaderShell from './HeaderShell';
import { Token } from '../../atom/atom'
import { useRecoilValue } from 'recoil';
import CreateAccountButton from './CreateAccountButton';

const pitchPages = ['Products', 'Pricing', 'Demo', 'About'];
const userPages = ['Scenarios', 'Resources', 'Statistics'];


export default function Header(props) {
  const isAuthenticated = useRecoilValue(Token)
  return (
    <HeaderShell>
      {/* <PageLinks pages={pitchPages} /> */}
      {
        isAuthenticated ?
          <UserMenu pages={userPages} />
          : <div><LoginButton /><CreateAccountButton /> <DemoButton /></div>
      }
    </HeaderShell>
  )
}